import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const bnStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'WhatsApp-এ আমন্ত্রণ জানান',
  NLSWhatsappInviteDialogTitle: 'WhatsApp-এ আমন্ত্রণ জানান',
  NLSWhatsappInviteDialogCopy: 'লিংক কপি করুন',
  NLSWhatsappInviteDialogShare: 'শেয়ার করুন',
  NLSWhatsappSendFromMineAction: 'আমার WhatsApp থেকে পাঠান',
  NLSWhatsappSendFromMineText: 'হ্যালো {name}, আমি {workspace} থেকে {sender}।',
  NLSWhatsappSlipQrCaption: 'WhatsApp-এ আমাদের সাথে চ্যাট করুন',
  NLSWhatsappChipLinked: 'WhatsApp লিঙ্ক করা হয়েছে',
  NLSWhatsappChipNotYet: 'WhatsApp: এখনও নয়',
  NLSWhatsappChipStopped: 'WhatsApp: বন্ধ',
  NLSEduAnnouncementSendWhatsappAction: 'WhatsApp-এ পাঠান',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'WhatsApp-এ পাঠান',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'পাঠান',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: '{n} জন অভিভাবককে পাঠানো হবে',
  NLSEduAnnouncementSendWhatsappSummaryCredits: '{n} জন অভিভাবককে পাঠানো হবে · প্রায় {credits} ক্রেডিট',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'আপনার প্ল্যানের সীমার অধীনে বিনামূল্যে',
  NLSEduAnnouncementSendWhatsappReasonOff: 'এই ওয়ার্কস্পেসের জন্য WhatsApp নিষ্ক্রিয় করা আছে।',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'সেটিংসে অ্যাডমিন ঘোষণার বার্তা পাঠানো বন্ধ রয়েছে।',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'যাচাইকৃত ফোন সম্মতি সহ কোনো অভিভাবক পাওয়া যায়নি।',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'অপর্যাপ্ত ক্রেডিটের কারণে WhatsApp পাঠানো স্থগিত আছে।',
  NLSEduAnnouncementSentWhatsappCount: 'WhatsApp-এ {count} জনকে পাঠানো হয়েছে',
  NLSCommonRailPageShellSidecarSheet: "বিস্তারিত প্যানেল",
  NLSCommonActionSignOut: 'সাইন আউট',
  NLSCommonLanguageLabel: 'ভাষা',
  NLSCommonLanguageAriaLabel: 'অ্যাপের ভাষা',
  NLSInvitesHelperAppLanguageTitle: 'Helper অ্যাপের ভাষা',
  NLSInvitesHelperAppLanguageBody: 'এই helper এই workspace-এ Helper অ্যাপের UI এই ভাষায় দেখবে.',
  NLSInvitesHelperAppLanguageAria: 'Helper অ্যাপের ভাষা',
  NLSMobileSettingsHelperAppLanguageTitle: 'Helper অ্যাপের ভাষা',
  NLSMobileSettingsHelperAppLanguageBody: 'শুধু Helper অ্যাপের বোতাম, সেটিংস ও UI বদলায়. Chat translation বদলায় না.',
  NLSMobileSettingsHelperAppLanguageSaved: 'Helper অ্যাপের ভাষা সেভ হয়েছে.',
  NLSHelperTabTodos: 'কাজ',
  NLSHelperTabCalendar: 'ক্যালেন্ডার',
  NLSHelperTabMeetings: 'মিটিং',
  NLSHelperTabChat: 'চ্যাট',
  NLSHelperTabControls: 'কন্ট্রোল',
  NLSHelperSubtabScan: 'স্ক্যান',
  NLSHelperSubtabMe: 'আমি',
  NLSHelperSubtabForms: 'ফর্ম',
  NLSHelperSubtabSync: 'সিঙ্ক',
  NLSHelperPanelSettings: 'Helper সেটিংস',
  NLSHelperPanelCommandPreferences: 'কমান্ড পছন্দ',
  NLSHelperSettingsTitle: 'সেটিংস',
  NLSHelperSettingsLanguage: 'ভাষা',
  NLSHelperSettingsLanguageAria: 'Helper ভাষা',
  NLSOpsRequestKindReliefNeeded: 'বিকল্প কর্মী প্রয়োজন',
  NLSOpsRequestKindIncident: 'ঘটনা',
  NLSOpsRequestKindClientComplaint: 'গ্রাহকের অভিযোগ',
  NLSOpsRequestKindSupplyRequest: 'সরবরাহের অনুরোধ',
  NLSOpsRequestKindPm: 'প্রতিরোধমূলক রক্ষণাবেক্ষণ',
  NLSOpsRequestKindCalibration: 'ক্যালিব্রেশন',
  NLSOpsReliefNeededTitle: 'বিকল্প কর্মী প্রয়োজন: {placeName}-এ {roleLabel} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'সাইট ও শিফট প্রতি ডিউটি পোস্ট · অনুপস্থিতি একটি বদলি অনুরোধ তৈরি করে',
  NLSOpsSitesSelectSite: 'সাইট নির্বাচন করুন',
  NLSOpsSitesDay: 'দিন',
  NLSOpsSitesSelectShift: 'শিফট নির্বাচন করুন',
  NLSOpsSitesPostsBoardTitle: 'পোস্ট ও বদলি',
  NLSOpsSitesColPost: 'পোস্ট',
  NLSOpsSitesColNeeds: 'প্রয়োজন',
  NLSOpsSitesColOnDuty: 'ডিউটিতে',
  NLSOpsSitesColState: 'অবস্থা',
  NLSOpsSitesStateCovered: 'আচ্ছাদিত',
  NLSOpsSitesStateShort: 'কম',
  NLSOpsSitesStateReliefNeeded: 'বদলি প্রয়োজন',
  NLSOpsSitesStateReliefAssigned: 'বদলি নিযুক্ত',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'অনুপস্থিত',
  NLSOpsSitesReliefInbox: 'বদলি ইনবক্স',
  NLSOpsSitesReliefFootnote: 'তালিকায় অনুপস্থিতি স্বয়ংক্রিয়ভাবে RELIEF_NEEDED অনুরোধ তৈরি করে এবং কভারেজ সতর্কবার্তা দেয় (A6)।',
  NLSOpsSitesFreeCandidates: 'উপলব্ধ প্রার্থী:',
  NLSOpsSitesOffToday: 'আজ ছুটি',
  NLSOpsSitesAssignBtn: 'নিযুক্ত করুন',
  NLSOpsSitesAssignCandidateBtn: '{name}-কে নিযুক্ত করুন',
  NLSOpsSitesAssignDialogTitle: 'বদলি কর্মী নিযুক্ত করুন',
  NLSOpsSitesPrintPostSheet: 'পোস্ট শিট প্রিন্ট করুন',
  NLSOpsSitesNoPosts: 'এই সাইটের জন্য কোনো ডিউটি পোস্ট কনফিগার করা নেই।',
  NLSOpsSitesNoReliefNeeded: 'কোনো বদলির প্রয়োজন নেই।',
  NLSOpsSitesNoSites: 'কোনো ক্লায়েন্ট সাইট পাওয়া যায়নি।',
  NLSOpsSitesNoShifts: 'কোনো শিফট উপলব্ধ নেই।',
  NLSOpsSitesPostSheetTitle: 'পোস্ট শিট · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'বদলি নিযুক্ত করা যাচ্ছে না: অনুরোধটি আর উন্মুক্ত নেই।',
  NLSOpsSitesErrorOnLeave: 'বদলি নিযুক্ত করা যাচ্ছে না: কর্মী অনুমোদিত ছুটিতে আছেন।',
  NLSOpsSitesErrorDoubleBooked: 'বদলি নিযুক্ত করা যাচ্ছে না: কর্মী ইতিমধ্যে এই শিফটে নিযুক্ত।',
  NLSOpsSitesErrorRoleCeiling: 'বদলি নিযুক্ত করা যাচ্ছে না: সদস্যের ভূমিকা সীমা ডিউটি বরাদ্দ প্রতিরোধ করে।',
  NLSOpsSitesErrorGeneric: 'বদলি নিযুক্ত করতে ব্যর্থ হয়েছে।',
  NLSOpsSitesErrorNotFound: 'রেকর্ড বা অনুরোধ পাওয়া যায়নি।',
  NLSOpsSitesErrorMissingAttributes: 'অনুরোধে প্রয়োজনীয় বদলি বৈশিষ্ট্যের ঘাটতি রয়েছে।',
  NLSOpsSitesErrorInactivePerson: 'বদলি নিযুক্ত করা যাচ্ছে না: কর্মী ওয়ার্কস্পেসে নিষ্ক্রিয়।',
  NLSOpsRequestsUnassigned: 'অনির্ধারিত',
  NLSOpsRequestsDetailUnassigned: 'অনির্ধারিত',
  NLSOpsSitesIncidentsSubtitle: 'ঘটনা (সীমাবদ্ধ) · ক্লায়েন্ট অভিযোগ · সরবরাহ অনুরোধ · সুপারভাইজার সাইট অডিট',
  NLSOpsSitesIncidentsTitle: 'ঘটনা',
  NLSOpsSitesRestrictedTag: 'সীমাবদ্ধ',
  NLSOpsSitesAuditScoresTitle: 'সাইট অডিট স্কোর',
  NLSOpsSitesSupervisorRegisterTag: 'সুপারভাইজার রেজিস্টার',
  NLSOpsSitesColSite: 'সাইট',
  NLSOpsSitesColLastAudit: 'সর্বশেষ অডিট',
  NLSOpsSitesColScore: 'স্কোর',
  NLSOpsSitesRecordAuditBtn: 'অডিট রেকর্ড করুন',
  NLSOpsSitesComplaintsSupplyTitle: 'অভিযোগ ও সরবরাহ অনুরোধ',
  NLSOpsSitesNoIncidents: 'কোনো ঘটনা রেকর্ড করা নেই।',
  NLSOpsSitesNoComplaintsSupply: 'কোনো অভিযোগ বা সরবরাহ অনুরোধ নেই।',
  NLSOpsSitesNoAudits: 'কোনো সাইট অডিট রেকর্ড করা নেই।',
  NLSOpsSitesNoAuditTemplate: 'কোনো সুপারভাইজার সাইট অডিট টেমপ্লেট কনফিগার করা নেই।',
  NLSOpsSitesOpenTemplatesBtn: 'টেমপ্লেট খুলুন',
} satisfies Partial<NlsStringMap>

export default bnStringsNls
